import UserWalletPaymentForm from './UserWalletPaymentForm';

export default UserWalletPaymentForm;
